import { isValidCellphoneInput } from '@solfacil/frontend-utils/cellphone';
import { isValidEmailInput } from '@solfacil/frontend-utils/email';
import { z } from 'zod';

import { nomeCompletoSchema } from './nomeCompletoSchema';

const celularRequiredSchema = z
  .string()
  .trim()
  .min(1, 'Celular é obrigatório')
  .refine((value) => isValidCellphoneInput(value), { message: 'Celular inválido' });

const emailOptionalSchema = z
  .string()
  .trim()
  .refine(
    (value) => value === '' || isValidEmailInput(value),
    { message: 'E-mail inválido' },
  );

const emailRequiredSchema = z
  .string()
  .trim()
  .min(1, 'E-mail é obrigatório')
  .refine((value) => isValidEmailInput(value), { message: 'E-mail inválido' });

export const DEFAULT_USER_PROFILE = 'integrador_light';
export const CREATE_USER_PROFILE_GERENTE = 'gerente';

export function getCreateUserProfile(partnerProfile?: string): string {
  return partnerProfile === 'basic' ? DEFAULT_USER_PROFILE : CREATE_USER_PROFILE_GERENTE;
}

export const userFormSchema = z.object({
  celular: celularRequiredSchema,
  email: emailOptionalSchema,
  nomeCompleto: nomeCompletoSchema,
});

export const createUserFormSchema = userFormSchema.extend({
  email: emailRequiredSchema,
});

/* eslint-disable perfectionist/sort-modules */
export type UserFormData = z.infer<typeof userFormSchema>;
export type CreateUserFormData = z.infer<typeof createUserFormSchema>;
